var customerLogin = function () {

    // Selectors object
    var selectors = {
        recoverPasswordLink: document.getElementById('RecoverPassword'),
        hideRecoverPasswordLink: document.getElementById('HideRecoverPasswordLink'),
        recoverPasswordForm: document.getElementById('RecoverPasswordForm'),
        customerLoginForm: document.getElementById('CustomerLoginForm')
    };
    
    // Local function name - not available outside this object
    var listeners = function (){
        if (!selectors.recoverPasswordLink) {
            return;
        }

        checkUrlHash();
        resetPasswordSuccess();
        
        selectors.recoverPasswordLink.addEventListener("click", onShowHidePasswordForm);
        selectors.hideRecoverPasswordLink.addEventListener("click", onShowHidePasswordForm);

        function onShowHidePasswordForm(evt) {
            evt.preventDefault();
            toggleRecoverPasswordForm();
        }

         function checkUrlHash() {
            var hash = window.location.hash;

            // Allow deep linking to recover password form
            if (hash === '#recover') {
                toggleRecoverPasswordForm();
            }
        }


        /**
         *  Show/Hide recover password form
         */
        function toggleRecoverPasswordForm() {
            selectors.recoverPasswordForm.classList.toggle('hide');
            selectors.customerLoginForm.classList.toggle('hide');
        }


        /**
         *  Show reset password success message
         */
        function resetPasswordSuccess() {
            var formState = document.querySelector('.reset-password-success');

            // check if reset password form was successfully submited.
            if (!formState) {
                return;
            }

            // show success message
            document.getElementById('ResetSuccess').classList.remove('hide');
        }


    };

    listeners();

}();